<template>
  <div>
    <!-- 单选题 -->
    <single-test
      v-if="baseType == 1"
      :key="'single-' + testId"
      :test="test"
      :testId="testId"
      :choiceAnswer="myAnswer"
      :tempResult="myAnswer"
      @change="change"
      @selectChange="selectChange">
    </single-test>
    <!-- 多选题 -->
    <multiple-test
      v-if="baseType == 2"
      :key="'multiple-' + testId"
      :test="test"
      :testId="testId"
      :choiceAnswer="myAnswer"
      :tempResult="myAnswer"
      :isMultipleType="true"
      @change="change"
      @selectChange="selectChange">
    </multiple-test>
    <!-- 判断题 -->
    <check-test
      v-if="baseType == 3"
      :key="'check-' + testId"
      :test="test"
      :testId="testId"
      :choiceAnswer="myAnswer"
      :tempResult="myAnswer"
      @change="change"
      @selectChange="selectChange">
    </check-test>
    <!-- 备选题 -->
    <choice-test
      v-if="baseType == 4"
      :key="'choice-' + testId"
      :test="test"
      :testId="testId"
      :choiceAnswer="myAnswer"
      :tempResult="myAnswer"
      @change="change"
      @selectChange="selectChange">
    </choice-test>
    <!-- 简答题 -->
    <shortAnswerTest 
      v-if="baseType == 5"
      :key="'short-' + testId"
      :test="test"
      :choiceAnswer="myAnswer"
      :tempResult="myAnswer"
      :testId="testId"
      @change="change"
      @selectChange="selectChange">
    </shortAnswerTest>
    <!-- 综合题 -->
    <comprehensive-test
      v-if="baseType == 6"
      :key="'comprehensive-' + testId"
      :test="test"
      :testId="testId"
      :choiceAnswer="myAnswer"
      :tempResult="myAnswer"
      :showAnswer="showAnswer"
      @change="change"
      @selectChange="selectChange"
      @previewImage="previewImage">
    </comprehensive-test>
    <!-- 答案解析（除了综合题） -->
    <answer v-if="showAnswer && baseType != 6" :test="test"></answer>
  </div>
</template>

<script>
import singleTest from '@/components/test/single-test.vue'; // 单选题
import multipleTest from '@/components/test/multiple-test.vue'; // 多选题
import checkTest from '@/components/test/check-test.vue'; // 判断题
import choiceTest from '@/components/test/choice-test.vue'; // 备选题
import shortAnswerTest from '@/components/test/short-answer-test.vue'; // 简答题
import comprehensiveTest from '@/components/test/comprehensive-test.vue'; // 综合题
import answer from '@/components/test/answer.vue'; // 答案解析

export default {
  components: {
    singleTest, // 单选题
    multipleTest, // 多选题
    checkTest, // 判断题
    choiceTest, // 备选题
    shortAnswerTest, // 简答题
    comprehensiveTest, // 综合题
    answer // 答案解析
  },

  props: {
    test: { // 题目
      type: Object,
      default: () => {},
    },

    baseType: { // 题目类型
      type: [Number, String],
      default: () => '',
    },

    myAnswer: { // 用户答案
      type: [String, Object],
      default: '',
    },

    testId: { // 题目ID
      type: Number,
      default: null,
    },
    
    showAnswer: { // 是否显示答案
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {};
  },

  methods: {
    change(e) {
      this.$emit('change', e);
    },
    selectChange(result) {
      this.$emit('selectChange', result);
    },
    previewImage(e) {
      this.$emit('previewImage', e);
    },
  },
};
</script>

<style></style>
